import React from 'react';

import TextBase from './TextBase';
import { TText } from './types';

const Large = ({ as = 'span', color = '', ...rest }: TText) => (
  <TextBase as={as} kind="body-large" color={color} {...rest} />
);

export default Large;
